module.exports = __webpack_public_path__ + "media/images/svg/logo-45e407bca00bf4f23baa4ca297f9e01d.svg";